export default function (content) {
	return this.html.element({tag: 'div', classes: ['field__inputWrapper'], content: content});
}
